import { languageMessages } from 'src/utils/messages';
import { LOCALE } from 'src/providers/types';

export const languageOptions = {
    [LOCALE.BG]: languageMessages.bulgarian,
    [LOCALE.EN]: languageMessages.english,
};
